import { Grid } from "@mui/material";
import React from "react";
import Base64Image from "../components/Base64Image/Base64Image";
//Yup
import * as Yup from "yup";
//formik
import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useFormik } from 'formik';
import { useState } from "react";
import { useSelector } from "react-redux";
import CheckPermissions from "../authorization/authorization";
import rotateLeftIcon from "../images/Rotate Left.png";
import rotateRightIcon from "../images/Rotate Right.png";
import zoomInIcon from "../images/Zoom In.png";
import zoomOutIcon from "../images/Zoom Out.png";

/**
 * OpenBase64ImageInPopup Component
 * 
 * This component renders an image inside a modal popup when triggered. It supports base64-encoded image strings
 * and allows users to view them in an enlarged format. The modal can be closed by clicking a close button or outside the image.
 * 
 * @component
 * @memberof Services
 * @param {Object} props - Component props
 * @param {boolean} props.docVerifyPopUp - Controls whether the modal is open or closed.
 * @param {Function} props.hideDocVerifyPopup - Callback function to close the modal.
 * @param {string} props.documentName - The name of the document being displayed.
 * @param {string} props.documentImage - The base64-encoded string of the front document image.
 * @param {string} [props.backDocumentImage] - The base64-encoded string of the back document image (optional).
 * @param {number} [props.width] - The width of the displayed document (optional).
 * @param {Object} [props.document] - Additional document-related data (optional).
 * @param {boolean} [props.documentFlag] - Flag indicating if the document is verified (optional).
 * @param {number} [props.applicationProgressId] - The ID representing the application's progress stage (optional).
 * @param {string} [props.objectionStatus] - The status of any objections related to the document (optional).
 * @param {Function} [props.updateDocFlag] - Callback function to update the document flag (optional).
 * @param {string} [props.titleToUpdateFlag] - The title related to the document flag update (optional).
 * @param {string} [props.documentRemarks] - Remarks or comments related to the document (optional).
 * @param {boolean} [props.flag_document] - Flag indicating a specific document status (optional).
 * @param {boolean} [props.flag_documentBack] - Flag indicating a specific back document status (optional).
 * @param {string} [props.parentService] - Parent service associated with the document (optional).
 * @returns {JSX.Element|null} The rendered component or null if `docVerifyPopUp` or `documentImage` is falsy.
 * 
 * @example
 * <OpenBase64ImageInPopup
 *   docVerifyPopUp={true}
 *   hideDocVerifyPopup={handleClose}
 *   documentName="Sample Document"
 *   documentImage={base64String}
 * />
 * 
 * @description
 * - Clicking outside the popup will close it via `hideDocVerifyPopup`.
 * - Clicking inside the popup stops propagation to prevent unintended closure.
 */
const OpenBase64ImageInPopup = ({
  docVerifyPopUp,
  hideDocVerifyPopup,
  documentName,
  documentImage,
  backDocumentImage,
  width,
  document,
  documentFlag,
  applicationProgressId,
  objectionStatus,
  updateDocFlag,
  titleToUpdateFlag,
  documentRemarks,
  flag_document,
  flag_documentBack,
  parentService
}) => {
  console.log( documentImage,
  backDocumentImage, "objectionStatus titleToUpdateFlag");
  const [rotationAngle, setRotationAngle] = useState(0);
  const [zoomLevel, setZoomLevel] = useState(1);

  const [showRemarksInput, setShowRemarksInput] = useState(false);
  const [remarks, setRemarks] = useState('');
  const rotateLeft = () => {
    setRotationAngle(rotationAngle - 90);
  };

  const { permissions } = useSelector((state) => state.auth)

  const rotateRight = () => {
    setRotationAngle(rotationAngle + 90);
  };

  const zoomIn = () => {
    setZoomLevel(zoomLevel + 0.1);
  };

  const zoomOut = () => {
    setZoomLevel(Math.max(zoomLevel - 0.1, 0.1));
  };

  const initialValues = {
    iv_remarks: ''
  }

  const remarksFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_remarks: Yup.string().required("Enter reason for objection.").min(10, "Reason should be between 10 to 200 characters!").max(200, "Reason should be between 10 to 200 characters!"),
    }),
    onSubmit: async (values, { resetForm }) => {
      updateDocFlag(titleToUpdateFlag, -1, values.iv_remarks)
    }
  })

  return (
    <Dialog
      open={docVerifyPopUp}
      onClose={() => hideDocVerifyPopup(false)}
      fullWidth={true}
      maxWidth={"lg"}
      className=""
    >
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{ width: "100%" }}>
          <h3 style={{ color: '#006ad1' }}>{documentName}</h3>
          {
            documentRemarks &&
            <p style={{ backgroundColor: documentRemarks === "Verified" ? 'lightgreen' : 'lightpink', color: 'grey', padding: '5px', fontSize: '15px', borderRadius: '5px' }}>Remarks: {documentRemarks}</p>
          }
        </div>
        {documentImage.slice(0, 6) == "data:i" && (
          <Grid
            container
            gap={2}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <button
              onClick={rotateLeft}
              style={{
                width: "40px",
                height: "40px",
                display: "flex",
                backgroundColor: '#006ad1',
                borderRadius: '5px',
                border: 'none',
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={rotateLeftIcon}
                alt="rotate left"
                style={{ width: "20px" }}
              />
            </button>
            <button
              onClick={rotateRight}
              style={{
                width: "40px",
                height: "40px",
                display: "flex",
                backgroundColor: '#006ad1',
                borderRadius: '5px',
                border: 'none',
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={rotateRightIcon}
                alt="rotate right"
                style={{ width: "20px" }}
              />
            </button>
            <button
              onClick={zoomIn}
              style={{
                width: "40px",
                height: "40px",
                display: "flex",
                color: 'white',
                backgroundColor: '#006ad1',
                borderRadius: '5px',
                border: 'none',
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={zoomInIcon}
                alt="Zoom In"
                style={{ width: "20px" }}
              />
            </button>
            <button
              onClick={zoomOut}
              style={{
                width: "40px",
                height: "40px",
                display: "flex",
                color: 'white',
                backgroundColor: '#006ad1',
                borderRadius: '5px',
                border: 'none',
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={zoomOutIcon}
                alt="Zoom Out"
                style={{ width: "20px" }}
              />
            </button>
          </Grid>
        )}
        <CloseIcon
          id="clearPopup"
          onClick={() => hideDocVerifyPopup(false)}
          sx={{ color: "red" }}
        />
      </DialogTitle>

      <hr style={{ margin: '0px 10px' }} />
      <DialogContent style={{ overflow: 'auto' }}>
        {backDocumentImage && <p>Front</p>}
        {documentImage && documentImage.slice(0, 6) == "data:i" ? (
          <div style={{ overflow: 'auto', maxHeight: '100%', maxWidth: '100%' }}>
            <Base64Image
              data={documentImage}
              width={width}
              height="auto"
              rotationAngle={rotationAngle}
              zoomLevel={zoomLevel}
            />
          </div>
        ) : documentImage && documentImage.slice(0, 6) == "data:a" ? (
          <embed
            src={documentImage}
            type="application/pdf"
            style={{
              width: "100%",
              height: backDocumentImage ? "500px" : "800px",
            }}
          />
        ) : null}
        {backDocumentImage && <p>Back</p>}
        {backDocumentImage && backDocumentImage.slice(0, 6) == "data:i" ? (
          <div style={{ overflow: 'auto', maxHeight: '100%', maxWidth: '100%' }}>
            <Base64Image
              data={backDocumentImage}
              width={width}
              height="auto"
              rotationAngle={rotationAngle}
              zoomLevel={zoomLevel}
            />
          </div>
        ) : backDocumentImage && backDocumentImage.slice(0, 6) == "data:a" ? (
          <embed
            src={backDocumentImage}
            type="application/pdf"
            style={{ width: "100%", height: "500px" }}
          />
        ) : null}
      </DialogContent>
      <DialogActions>
        <Grid
          container
          sx={{ display: "flex", justifyContent: "space-evenly" }}
        >
          {CheckPermissions(permissions,
            "General Services",
            "New Connection",
            "Workflow Permissions",
            "Document Verification"
          ) &&
            document &&
            (flag_document == null || flag_document == 0 || flag_document == 2) &&
            (parentService == 'courtOrder' ? applicationProgressId === 0 : applicationProgressId === 1) &&
            objectionStatus !== 1 ? (
            <>
              {showRemarksInput ?
                <Grid item sx={{ display: 'flex', gap: 2, justifyContent: 'space-between', height: '70px', alignItems: 'end' }}>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label>Reason for rejection:</label>
                    <input type="text" name='iv_remarks' value={remarksFormik.values.iv_remarks} onBlur={remarksFormik.handleBlur} onChange={remarksFormik.handleChange} style={{ width: '250px', height: 'auto', padding: '10px' }} />
                    <p style={{ color: 'red' }}>{remarksFormik.errors.iv_remarks && remarksFormik.touched.iv_remarks ? (remarksFormik.errors.iv_remarks) : null}</p>
                  </div>
                  <button style={{
                    // backgroundColor:
                    //   flag_document !== -1 ? "lightgrey" : "lightpink",
                    background: "linear-gradient( #4BDFA7, #0B573B)",
                    padding: "10px 50px",
                    height: '40px',
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    border: "none",
                    borderRadius: "5px",
                    color: 'white'
                  }}
                    onClick={remarksFormik.handleSubmit}
                  >Submit</button>
                  <button onClick={() => { remarksFormik.resetForm(); setShowRemarksInput(false) }}
                    style={{
                      // backgroundColor:
                      //   flag_document !== -1 ? "lightgrey" : "lightpink",
                      background: "linear-gradient( #F1405D, #910E24)",
                      padding: "10px 50px",
                      display: "flex",
                      height: '40px',
                      alignItems: "center",
                      justifyContent: "space-between",
                      border: "none",
                      borderRadius: "5px",
                      color: 'white'
                    }}>Cancel</button>
                </Grid>
                :
                <>
                  <Grid item className="icon1">
                    <button
                      // onClick={() => updateDocFlag(titleToUpdateFlag, -1,)}
                      onClick={() => setShowRemarksInput(true)}
                      style={{
                        // backgroundColor:
                        //   flag_document !== -1 ? "lightgrey" : "lightpink",
                        background: "linear-gradient( #F1405D, #910E24)",
                        padding: "10px 50px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        border: "none",
                        borderRadius: "5px",
                        color: 'white'
                      }}
                    >
                      Reject
                    </button>
                  </Grid>
                  <Grid item className="icon2">
                    <button
                      onClick={() => updateDocFlag(titleToUpdateFlag, 1, 'Verified')}
                      style={{
                        // backgroundColor:
                        //   flag_document !== 1 ? "lightgrey" : "lightgreen",
                        background: "linear-gradient( #4BDFA7, #0B573B)",
                        padding: "10px 50px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        border: "none",
                        borderRadius: "5px",
                        color: 'white'
                      }}
                    >
                      Accept
                    </button>
                  </Grid>
                </>
              }
            </>
          ) : null}
        </Grid>
      </DialogActions>
    </Dialog >
  );
};
export default OpenBase64ImageInPopup;